module.exports = __webpack_public_path__ + "img/myMind-red.ecba5927.svg";